import LineOrange from "../../../common/LineOrange/LineOrange";

export const ApplicationOfTheCertificate = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "50vh", backgroundColor: "#F2F4F6" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5">مزایای گواهی سپرده کالایی</h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-center justify-content-center mb-5"
            style={{ minHeight: "50vh" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-6">
                <ul className="text-right mt-3">
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نقد کردن کالاهای راکد در انبار
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    کاهش هزینه انبارداری
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    مدیریت تولید و مصرف
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                     کنترل قیمتها
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                      تامین مالی سریع و ارزان
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                     استانداردسازی کالاها 
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                      معافیت مالیاتی
                  </li>
                </ul>
              </div>
              <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/02.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
